import { Dayjs } from 'dayjs';

import { SDate } from '@summit/core';

import { EboObject } from '../base-classes/ebo-object';
import { TruckStatus, TruckStatusMapping } from './truck-status.enum';

export class TruckStatusHistory extends EboObject {
  truckID: string;
  //truck: Truck;
  status: TruckStatus;
  effectiveDate: Dayjs;

  constructor(jsonData?: Partial<TruckStatusHistory>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.effectiveDate) {
        this.effectiveDate = SDate.newUtc(jsonData.effectiveDate);
      }
    }
    this.effectiveDate ??= SDate.getNormalized();
  }

  toShortString(): string {
    return `${this.effectiveDate.format('M/D/YY')} - ${TruckStatusMapping[this.status]}`;
  }

  get statusName(): string {
    return TruckStatusMapping[this.status];
  }
}
